import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import { BRAND } from '../lib/brand';

const routeContext = {
  '/': {
    eyebrow: 'Platform overview',
    ctaLabel: 'Explore the dashboards',
    ctaTo: '/chronic-disease',
  },
  '/chronic-disease': {
    eyebrow: 'Disease insights',
    ctaLabel: 'See yourself in the data',
    ctaTo: '/risk',
  },
  '/autoimmune': {
    eyebrow: 'Autoimmune intelligence',
    ctaLabel: 'Learn public health basics',
    ctaTo: '/learn',
  },
  '/vaccines': {
    eyebrow: 'Vaccines & prevention',
    ctaLabel: 'View transparency sources',
    ctaTo: '/sources',
  },
  '/news': {
    eyebrow: 'Latest updates',
    ctaLabel: 'Understand the methods',
    ctaTo: '/methods',
  },
  '/risk': {
    eyebrow: 'Personal context',
    ctaLabel: 'Compare national data',
    ctaTo: '/explorer',
  },
  '/learn': {
    eyebrow: 'Beginner-friendly learning',
    ctaLabel: 'Explore vaccine insights',
    ctaTo: '/vaccines',
  },
  '/explorer': {
    eyebrow: 'Interactive analysis',
    ctaLabel: 'Review source transparency',
    ctaTo: '/sources',
  },
  '/sources': {
    eyebrow: 'Open data & sourcing',
    ctaLabel: 'Return to the homepage',
    ctaTo: '/',
  },
  '/methods': {
    eyebrow: 'How evidence works',
    ctaLabel: 'Go back to learning',
    ctaTo: '/learn',
  },
};

export default function SiteIdentityBanner() {
  const location = useLocation();
  const ctx = routeContext[location.pathname] || routeContext['/'];

  return (
    <section className="relative overflow-hidden border-b border-violet-200/60 bg-white/90 backdrop-blur-xl" data-testid="site-identity-banner">
      <div className="absolute inset-0 brand-gradient opacity-[0.10]" />
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-violet-400/70 to-transparent" />
      <div className="relative mx-auto flex max-w-7xl flex-col gap-4 px-4 py-4 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8">
        <div className="min-w-0">
          <div className="mb-2 inline-flex items-center gap-2 rounded-full border border-violet-200/80 bg-white/80 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.22em] text-violet-700 shadow-sm">
            <Sparkles className="h-3.5 w-3.5" />
            {ctx.eyebrow}
          </div>
          <h2 className="max-w-4xl text-base font-bold tracking-tight text-slate-950 sm:text-lg lg:text-xl">
            {BRAND.headline}
          </h2>
          <p className="mt-1 max-w-4xl text-xs leading-relaxed text-slate-600 sm:text-sm">
            {BRAND.subheadline}
          </p>
        </div>
        <Link
          to={ctx.ctaTo}
          className="inline-flex shrink-0 items-center justify-center gap-2 rounded-full brand-button px-4 py-2 text-sm font-semibold text-white shadow-lg shadow-violet-900/15"
          data-testid="identity-banner-cta"
        >
          {ctx.ctaLabel}
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </section>
  );
}
